import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchTermsPipe } from './search-terms.pipe';

@NgModule({
  declarations: [SearchTermsPipe],
  imports: [CommonModule],
  exports: [SearchTermsPipe],
})
export class SearchTermsPipeModule {}
